export const DUTY_VALUE_SOURCE_CUSTOM = 'custom';
export const DUTY_VALUE_SOURCE_SCALE = 'scale';
export const DUTY_VALUE_SOURCE_USER_GROUP = 'user_group';
export const DUTY_VALUE_SOURCE_USER_SCALE = 'user_scale';
